import Image from 'next/image';
import React from 'react';

interface CarouselSlideProps {
  src: string;
  alt: string;
  isActive: boolean;
  priority?: boolean;
}

/**
 * Individual carousel slide component
 * Optimized for mobile performance with Next.js Image
 */
export function CarouselSlide({ src, alt, isActive: _isActive, priority = false }: CarouselSlideProps) {
  return (
    <div className="relative w-screen h-full flex-shrink-0">
      <Image
        src={src}
        alt={alt}
        fill
        sizes="100vw"
        quality={60}
        className="object-cover"
        priority={priority}
        fetchPriority={priority ? 'high' : 'auto'}
        loading={priority ? 'eager' : 'lazy'}
        // A tiny inline-SVG gray placeholder paints under the hero `<img>` the
        // moment the layout resolves, well before the full image bytes arrive.
        // The LCP candidate is now this neutral block at FCP time, not the
        // full image 1+ s later. The Image component fades the real bytes in
        // on top once they're decoded.
        placeholder="blur"
        blurDataURL="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxIDEiPjxyZWN0IGZpbGw9IiNlNWU3ZWIiIHdpZHRoPSIxIiBoZWlnaHQ9IjEiLz48L3N2Zz4="
      />
    </div>
  );
}
